import { SxStyles } from 'types';

export const wrapperWithTimeline: SxStyles = {
  position: 'relative',
  paddingLeft: '60px',
};

export const wrapperTopMargin: SxStyles = (theme) => {
  return {
    marginTop: '16px',

    [theme.breakpoints.down('commonSm')]: {
      marginTop: '12px',
    },
  };
};

export const timeline: SxStyles = {
  position: 'absolute',
  top: 0,
  left: '28px',
};
